import { ExtractPropTypes } from 'vue';

export const props = {
  error: {
    type: Boolean,
  },
};

export type Props = ExtractPropTypes<typeof props>;
